import { z } from 'zod';

/**
 * Билет участника (#147, задача 1). QR несёт `upme-ticket:<ticketId>.<tokenVersion>.<sig>`:
 * подпись проверяет только API, а разбор без подписи нужен и клиенту — отличить
 * QR билета от QR профиля/события при скане.
 */
export const TICKET_QR_PREFIX = 'upme-ticket:';

const TICKET_QR_RE =
  /^upme-ticket:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\.([1-9]\d{0,8})\.([0-9a-f]{32})$/;

export function parseTicketQr(raw: string): { ticketId: string; tokenVersion: number; sig: string } | null {
  const m = TICKET_QR_RE.exec(raw.trim());
  if (!m) return null;
  const [, ticketId, version, sig] = m;
  if (!ticketId || !version || !sig) return null;
  return { ticketId, tokenVersion: Number(version), sig };
}

export const TicketStatus = z.enum(['ACTIVE', 'CHECKED_IN', 'CANCELLED']);
export type TicketStatus = z.infer<typeof TicketStatus>;

export const MyTicketDto = z.object({
  id: z.uuid(),
  eventId: z.uuid(),
  /** CANCELLED наружу не отдаётся — вместо него 404 ticket_not_available. */
  status: z.enum(['ACTIVE', 'CHECKED_IN']),
  /** Строка для QR как есть. */
  qrPayload: z.string(),
  checkedInAt: z.iso.datetime().nullable(),
  /** displayNameOf(user) — то же имя, что видит организатор при скане. */
  holderName: z.string(),
});
export type MyTicketDto = z.infer<typeof MyTicketDto>;

export const CheckInByQrInput = z.object({ qr: z.string().min(1).max(200) });
export type CheckInByQrInput = z.infer<typeof CheckInByQrInput>;

export const CheckInResultDto = z.object({
  result: z.enum(['CHECKED_IN', 'ALREADY_CHECKED_IN']),
  ticketId: z.uuid(),
  checkedInAt: z.iso.datetime(),
  guest: z.object({
    id: z.uuid(),
    /** displayNameOf(user) — совпадает с MyTicketDto.holderName. */
    holderName: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    username: z.string().nullable(),
    photoUrl: z.string().nullable(),
  }),
});
export type CheckInResultDto = z.infer<typeof CheckInResultDto>;
